var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListList = function SvgListList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 20H18.1c-.5 0-1-.5-1-1s.5-1 1-1h12.1c.5 0 1 .5 1 1-.1.5-.5 1-1 1zM30.2 25H18.1c-.5 0-1-.5-1-1s.5-1 1-1h12.1c.5 0 1 .5 1 1-.1.5-.5 1-1 1zM30.2 30H18.1c-.5 0-1-.5-1-1s.5-1 1-1h12.1c.5 0 1 .5 1 1-.1.5-.5 1-1 1z"
  })));
};
export default SvgListList;